import { useQuery } from "@tanstack/react-query";
import { blockKeys, blocksApi } from "./api";

export function useBlocks(category: string, search: string) {
  return useQuery({
    queryKey: blockKeys.list(category, search),
    queryFn: () => blocksApi.list({ category, search }),
    // The registry is authored in git and only changes on deploy, so there is
    // nothing to poll for — keep it fresh for the whole session.
    staleTime: Infinity,
  });
}

export function useBlock(slug: string) {
  return useQuery({
    queryKey: blockKeys.detail(slug),
    queryFn: () => blocksApi.get(slug),
    staleTime: Infinity,
  });
}

export function useCategories() {
  return useQuery({
    queryKey: blockKeys.categories(),
    queryFn: blocksApi.categories,
    staleTime: Infinity,
  });
}
